// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"TabPanel_tabContainer__3-XXB"};